import { render, staticRenderFns } from "./DownloadHistoricoDialog.vue?vue&type=template&id=00cc5fb4&"
import script from "./DownloadHistoricoDialog.vue?vue&type=script&lang=js&"
export * from "./DownloadHistoricoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports